import * as xssFilters from 'xss-filters';
import { Article, WebsiteInformation } from '../../models';
import { changeSvgToPng } from "@jcharlesworthuk/your-mum-core/dist/functions/url-helpers";

export function getArticleStructuredData(article: Article, website: WebsiteInformation) {
  return xssFilters.inHTMLData(JSON.stringify({
    "@context": "http://schema.org/",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `${website.siteUrl}${article.route}`
    },
    "datePublished": article.date.toISOString(),
    "dateModified": article.date.toISOString(),
    "headline": article.title,
    "image": `${website.siteUrl}${changeSvgToPng(article.mainImage)}`,
    "author": {
      "@type": "Organization",
      "name": website.name
    },
    "publisher": {
      "@type": "Organization",
      "name": website.name,
      "logo": {
        "@type": "ImageObject",
        "url": website.siteLogoUrlSquare
      }
    },
    "description": article.standfirst
  }));
}
